import { render, staticRenderFns } from "./MainLayout2.vue?vue&type=template&id=c9908fb4&scoped=true&"
import script from "./MainLayout2.vue?vue&type=script&lang=js&"
export * from "./MainLayout2.vue?vue&type=script&lang=js&"
import style0 from "./MainLayout2.vue?vue&type=style&index=0&id=c9908fb4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9908fb4",
  null
  
)

export default component.exports